module.exports = __webpack_public_path__ + "static/img/moocs-series6-1.3574ca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/moocs-series6-1.png
// module id = t0uY
// module chunks = 0